import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "./locales/en.json";
import hi from "./locales/hi.json";

const isServer = typeof window === 'undefined';

// Create i18next instance
const i18n = i18next.createInstance();

// CLIENT: Initialize with browser language detector and localStorage
// SERVER: Skip initialization - the server uses I18nextProvider with server/i18n-server.js
if (!isServer) {
    i18n
        .use(initReactI18next)
        .use(LanguageDetector)
        .init({
            resources: {
                en: { translation: en },
                hi: { translation: hi },
            },
            fallbackLng: "en",
            debug: false,
            interpolation: {
                escapeValue: false,
            },
            react: {
                useSuspense: false, // Critical for SSR hydration
            },
        });

    // Load saved language from localStorage
    const savedLang = localStorage.getItem("appLanguage") || "en";
    i18n.changeLanguage(savedLang);
}

export default i18n;